const BannerGrey=()=>{
return(
    <div className="greyBg text-center mt-32 d-flex align-items-center justify-content-center">
       <span className="grey66"> <img src="/images/coin-unbroken.svg" alt=' coin icon'  className="mr-8" /> 0 frais cachés</span>
        <span className="ellipse mx-8"></span>
         <span className="grey66"><img src="/images/check-01.svg" alt=' check icon'  className="mr-8"/>Inscription facile & gratuite</span>
        <span className="ellipse mx-8"></span>
        <span className="grey66"><img src="/images/users-profiles-01.svg" alt=' coin icon'  className="mr-8" /> Service client 7j/7</span>
    </div>
)
}
export default BannerGrey